import React from 'react';
import {Multilingual, CodeEditor } from 'hyperdb-utils';
const MultilingualCodeEditor = Multilingual(CodeEditor);

const TextsTab = ({
  objectData, websiteContent = {}, availableLocales, onChange,
  defaultLanguage, availableLanguages,
}) => {
  const handleChange = (attributeName, field) => {
    const content = { ...websiteContent };
    content[attributeName] = field.value;
    onChange(content);
  };
  const handleChangeLocalized = (attributeName, field) => {
    const { name, value } = field;
    handleChange(attributeName, { value: { $i18n: value } });
  };
  const localizedValue = (attributeName) => {
    return (websiteContent[attributeName] || {}).$i18n;
  };
  return (
    <fieldset>
      <MultilingualCodeEditor
        mode="markdown"
        label="Property information"
        name="property_information"
        value={ localizedValue('property_information') }
        onChange={ handleChangeLocalized.bind(null, 'property_information') }
        availableLocales={ availableLocales }
      />
      <MultilingualCodeEditor
        mode="markdown"
        label="Location information"
        name="location_information"
        value={ localizedValue('location_information') }
        onChange={ handleChangeLocalized.bind(null, 'location_information') }
        availableLocales={ availableLocales }
      />
      <MultilingualCodeEditor
        mode="markdown"
        label="Rental information"
        name="rental_information"
        value={ localizedValue('rental_information') }
        onChange={ handleChangeLocalized.bind(null, 'rental_information') }
        availableLocales={ availableLocales }
      />
    </fieldset>
  );
};

export default TextsTab;



// WEBPACK FOOTER //
// ./src/frontend/modules/content/property-content/components/TextsTab.jsx